import { loadStripe, Stripe } from '@stripe/stripe-js'

const publishableKey = process.env.NODE_ENV === 'production'
  ? process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
  : process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY_TEST

let stripePromise: Promise<Stripe | null> | null = null

export const getStripe = (): Promise<Stripe | null> => {
  if (!publishableKey) {
    throw new Error('Missing NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY')
  }
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey)
  }
  return stripePromise
}

// Cache of stripe instances scoped to each connected account (for delivery payments).
const stripeConnectCache = new Map<string, Promise<Stripe | null>>()

export const getStripeForAccount = (connectAccountId: string): Promise<Stripe | null> => {
  if (!publishableKey) {
    throw new Error('Missing NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY')
  }
  if (!stripeConnectCache.has(connectAccountId)) {
    stripeConnectCache.set(
      connectAccountId,
      loadStripe(publishableKey, { stripeAccount: connectAccountId })
    )
  }
  return stripeConnectCache.get(connectAccountId)!
}
